import { gql } from '@apollo/client'

export const GET_TENANT_USERS = gql`
  query GetTenantUsers(
    $pagination: OffsetPaginationInput
    $filters: UserFilter
    $order: UserOrder
  ) {
    tenantUsers(filters: $filters, order: $order, pagination: $pagination) {
      results {
        id
        email
        firstName
        lastName
        username
        isActive
        phoneNumber
        phoneNumberVerified
        jobTitle
        pinNumber
        groups {
          id
          name
          isOwner
        }
        stores {
          id
        }
        isStaff
        externalId
        dateJoined
        dateRemoved
      }
      pageInfo {
        limit
        offset
      }
      totalCount
    }
  }
`
